<img [src]="resource" [width]="width" [height]="height">